module.exports = __webpack_public_path__ + "img/a6fe8bd1-39aa-479a-8b11-984ab9eb5bed.webp.8d54a592.jpg";